import React, { useState, useEffect } from "react";
import { BsPlusLg } from "react-icons/bs";
import MultiInputTagImage from "./MultiInputTagImage";

const NestedInputImage = ({ item }) => {
  const { label, name, type, multiple, multipleData, required } = item;
  const [indexState, setIndexState] = useState(multipleData?.length);

  const [quantityCount, setCount] = useState(
    multipleData
      ? multipleData.map((subItem, index) => (
          <MultiInputTagImage
            key={subItem.label}
            id={subItem.id}
            label={`${label} ${index + 1}`}
            // length={index + 1}
            name={subItem.name}
            defaultImage={subItem?.defaultImage?.url}
            defaultValue={
              subItem?.defaultImage?.title ? subItem?.defaultImage?.title : ""
            }
            type={type}
            required={required}
            handleRemoveElement={handleRemoveElement}
          />
        ))
      : [
          <MultiInputTagImage
            key={item.label}
            id={item.id}
            label={item.label}
            // length={index + 1}
            name={name}
            defaultImage={item?.defaultImage?.url}
            defaultValue={
              item?.defaultImage?.title ? item?.defaultImage?.title : ""
            }
            type={type}
            required={required}
            handleRemoveElement={handleRemoveElement}
          />,
        ]
  );

  const handleAddElement = () => {
    // setCount((current) => [
    //   ...current,
    //   {
    //     label: label,
    //     type: "text",
    //     name: "",
    //     defaultValue: [],
    //   },
    // ]);

    setCount((current) => [
      ...current,
      <MultiInputTagImage
        key={`${label} ${indexState + 1}`}
        id={`client-image-new-007${indexState + 1}`}
        label={`${label} ${indexState + 1}`}
        name={name}
        defaultImage={""}
        defaultValue={""}
        type={type}
        required={required}
        handleRemoveElement={handleRemoveElement}
      />,
    ]);
  };

  // set "IndexState" length based on the length of main array
  useEffect(() => {
    setIndexState(quantityCount.length);
  }, [quantityCount]);

  // DELETE (pass "label" as argument)
  function handleRemoveElement(id, index) {
    console.log(id, "from remove");
    const filteredValue = [...quantityCount].filter(
      (item) => item?.props?.id !== id
    );

    setCount(
      filteredValue.map((item, index) => (
        <MultiInputTagImage
          key={item.props.label}
          id={item.props.id}
          label={`${label} ${index + 1}`}
          // length={index + 1}
          name={item.props.name}
          defaultImage={item?.props.defaultImage}
          defaultValue={
            item?.props.defaultValue ? item?.props.defaultValue : ""
          }
          type={type}
          required={required}
          handleRemoveElement={handleRemoveElement}
        />
      ))
    );
  }

  return (
    <div className="col-span-1 lg:col-span-2 flex flex-row gap-4 items-centers w-full fitHeight  ">
      <div className="w-full">
        {/* {quantityCount.map((item, index) => (
          <MultiInputTagImage
            key={index}
            label={label}
            length={index + 1}
            name={name}
            defaultImage={item?.defaultImage?.url}
            defaultValue={
              item?.defaultImage?.title ? item?.defaultImage?.title : ""
            }
            type={type}
            required={required}
          />
        ))} */}
        {quantityCount?.map((item) => item)}
      </div>

      {multiple && (
        <div className="flex justify-center items-end">
          <button
            onClick={handleAddElement}
            type="button"
            className="btn btn-circle"
          >
            <BsPlusLg />
          </button>
        </div>
      )}
    </div>
  );
};

export default NestedInputImage;
